import { PASSPORT_PAGE_NUMBERS } from '../../FileUpload.constants';

export const usePassportDocInfoPresenter = ({ pageList }) => {
  const pageListExist = PASSPORT_PAGE_NUMBERS.reduce((list, page) => {
    if (!pageList.some((p) => page === p.classification.pages)) {
      return [...list, page];
    }

    return list;
  }, []);

  const getColor = (page) => {
    return pageListExist.some((p) => p === page);
  };

  return {
    getColor,
  };
};
